import React, { Component } from "react";
import BuildCatalog from "./buildCatalog";
import StorePreview from "./storePreview";

class BuildMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreview: false,
      products:[]
    };
  }
  onChangePreview = () => {
    this.setState({
      isPreview: !this.state.isPreview,
    });
  };
  onAdd=(data)=>{
    this.setState({
      products:data
    })
  }
  render() {
    console.log('product-data==>',this.state.products)
    return (
      <div>
        {!this.state.isPreview ? (
          <BuildCatalog onChangePreview={this.onChangePreview} onAdd={this.onAdd} />
        ) : (
          <StorePreview onChangePreview={this.onChangePreview} products={this.state.products} />
        )}
      </div>
    );
  }
}
export default BuildMain;
